package horcrux.frontend.common.views.documents.dialogs

import arrow.core.toOption
import horcrux.common.api.dtos.types.DocumentMetadata
import horcrux.common.utils.eitherWay
import horcrux.frontend.common.BooleanState
import horcrux.frontend.common.GlobalAppState
import horcrux.frontend.common.MaybeState
import horcrux.frontend.common.isInvalid
import horcrux.frontend.common.views.collections.importdocuments.EditDocumentName
import horcrux.frontend.common.views.components.containers.DialogAction
import horcrux.frontend.common.views.components.containers.DialogView
import horcrux.frontend.common.views.documents.DocumentNavigatorMenuOption
import js.objects.jso
import mui.material.AlertColor
import mui.material.DialogContentText
import mui.system.sx
import react.FC
import react.Props
import react.ReactNode
import web.cssom.px

external interface EditDocumentNameProps : Props {
    var showDialogState: BooleanState
    var currentDocumentMetadata: DocumentMetadata
    var documentMetadataList: List<DocumentMetadata>
    var onSuccess: (DocumentMetadata) -> Unit
    var globalAppState: GlobalAppState
}

val EditDocumentNameDialog = FC<EditDocumentNameProps> { props ->
    val documentNameMaybeState = MaybeState(props.currentDocumentMetadata.documentName)
    val isDocumentNameInvalid = documentNameMaybeState.isInvalid()

    fun closeDialog() {
        documentNameMaybeState.reset()
        props.showDialogState.setFalse()
    }

    DialogView {
        this.title = DocumentNavigatorMenuOption.EDIT_DOCUMENT_NAME.viewName
        this.showDialogState = props.showDialogState
        this.dialogActionsMaybe = listOf(
            DialogAction("Cancel") { _, _ ->
                closeDialog()
            },
            DialogAction("Submit") { _, isLoadingState ->
                documentNameMaybeState
                    .get()
                    .toOption()
                    .filter { !isDocumentNameInvalid }
                    .map { newDocumentName ->
                        props.globalAppState.submitBackendAPIRequestAsync { backendClient ->
                            isLoadingState.setTrue()
                            backendClient.renameDocument(
                                props.currentDocumentMetadata.documentID,
                                props.currentDocumentMetadata.collectionID,
                                newDocumentName
                            )
                                .map {
                                    props.onSuccess(it.documentMetadata)
                                    closeDialog()
                                    props.globalAppState.updateBanner(AlertColor.success, "Document renamed!")
                                }.eitherWay { isLoadingState.setFalse() }.bind()
                        }
                    }
            }
        )
        DialogContentText {
            +"Enter a new name for the document"
        }
        EditDocumentName {
            this.textFieldValueMaybeState = documentNameMaybeState
            this.textFieldPropsMaybe = jso {
                this.autoFocus = true
                this.error = isDocumentNameInvalid
                this.helperText =
                    if (isDocumentNameInvalid) ReactNode("Document name is invalid") else null
                this.sx {
                    this.width = 450.px
                    this.marginTop = 20.px
                }
            }
        }
    }
}
